import { getRudderstack } from '@ecomm/shared-window'

/**
 * Track footer click events.
 */
export function trackFooterClick({
  selection
}: {
  readonly selection: string
}) {
  getRudderstack(r =>
    r.track('footer_clicked', {
      selection
    })
  )
}
